export interface PickupRequestActionTypes {
  type: PickupRequestActions;
  payload?: any;
}

export enum PickupRequestActions {
  CREATE_PICKUP_REQUEST = "CREATE_PICKUP_REQUEST",
  GET_PICKUP_REQUEST_LIST = "GET_PICKUP_REQUEST_LIST",
  SET_PICKUP_REQUEST_LIST = "SET_PICKUP_REQUEST_LIST",
  SET_PICKUP_REQUEST_PAGE_COUNT = "SET_PICKUP_REQUEST_PAGE_COUNT",
  GET_PICKUP_REQUEST_DATA_BY_ID = "GET_PICKUP_REQUEST_DATA_BY_ID",
  SET_PICKUP_REQUEST_DATA_BY_ID = "SET_PICKUP_REQUEST_DATA_BY_ID",
  EDIT_PICKUP_REQUEST_DATA_BY_ID = "EDIT_PICKUP_REQUEST_DATA_BY_ID",
}
